import { PartialType } from '../../../utils';
import { CreateUserAuthorityDto } from './create-user-authority.dto';
export class UpdateUserAuthorityDto extends PartialType(CreateUserAuthorityDto) {
}
